import React, { useState } from "react";
import "./Subtotal.css";
import CurrencyInput from "react-currency-input-field";
import { useStateValue } from "./StateProvider";
import { getCartTotal } from "./reducer";

export default function Subtotal() {
  const [{ cart }] = useStateValue();
  const [coupon, setCoupon] = useState("");
  const [discountApplied, setDiscountApplied] = useState(false);
  const [error, setError] = useState("");

  const subtotal = getCartTotal(cart);
  const discount = discountApplied ? subtotal * 0.2 : 0;
  const total = subtotal - discount;

  const handleApplyCoupon = () => {
    const validCoupon = "SAVE20"; // Example coupon code
    if (coupon.trim().toUpperCase() === validCoupon) {
      setDiscountApplied(true);
      setError("");
    } else {
      setDiscountApplied(false);
      setError("Invalid coupon code");
    }
  };

  return (
    <div className="subtotal">
      <p>
        Subtotal ({cart.length} items):{" "}
        <strong>
          
          $ <CurrencyInput
            value={total}
            decimalsLimit={2}
            readOnly
            className="currencyInput"
          />
        </strong>
      </p>

      {discountApplied && (
        <p style={{ color: "green" }}>Coupon applied! 20% discount</p>
      )}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="coupon">
        <input
          type="text"
          placeholder="code: SAVE20"
          value={coupon}
          onChange={(e) => setCoupon(e.target.value)}
          disabled={discountApplied}
        />
        <button onClick={handleApplyCoupon} disabled={discountApplied}>
          Apply
        </button>
      </div>

      <small className="subtotal__gift">
        <input type="checkbox" /> This order contains a gift
      </small>
      <button>Proceed to Payment</button>
    </div>
  );
}
